/** MakeCode Arcade img` 한 줄: 픽셀 사이 공백은 가독용이므로 제거 후 한 글자 = 한 픽셀 */
export const normalizeMakecodeImgRow = (line: string): string => line.replace(/\s/g, '');

export const parseImgTemplatePixelRows = (imgInner: string): string[] => {
  return imgInner
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map(normalizeMakecodeImgRow)
    .filter((row) => row.length > 0);
};

export const getImgTemplateSize = (imgInner: string): { width: number; height: number } => {
  const rows = parseImgTemplatePixelRows(imgInner);
  if (rows.length === 0) return { width: 0, height: 0 };
  return {
    width: Math.max(...rows.map((r) => r.length)),
    height: rows.length,
  };
};
